<div class="inner-wrapper full-fill bg-{{ color }} {{ innerCssClass }}">
  <ng-content></ng-content>
</div>
